import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import QuIcon from '@quiqupltd/qu-react-sdk/lib/components/qu-icon';
import { Container, Header, Content } from './styles';

export default class ArrivedCardHeader extends PureComponent {
  static propTypes = {
    onToggleOpenCard: PropTypes.func.isRequired,
  };

  render() {
    const { onToggleOpenCard } = this.props;

    return (
      <Container onClick={onToggleOpenCard}>
        <div>
          <Header>Your driver has arrived</Header>
          <Content>They should be just outside</Content>
        </div>
        <QuIcon icon="chevron-up" width={20} height={20} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/order-card/arrived/header/ArrivedCardHeader.js